import history from 'history/browser'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import './Bloc.css'

class BlocParcoursEstimer extends Component {
    constructor(props) {
        super(props)
        this.handleClickBloc = this.handleClickBloc.bind(this)
    }

    handleClickBloc() {
        if (
            this.props.linked_data_id &&
            this.props.linked_data_value !== undefined
        ) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: this.props.linked_data_id,
                    value: this.props.linked_data_value,
                },
            })
        }
        if (this.props.linked_data_id && this.props.linked_data_value_empty) {
            store.dispatch({
                type: 'SET',
                value: { key: this.props.linked_data_id, value: undefined },
            })
        }
        if (this.props.targetView) {
            history.push('/tunnelmobile/', {
                targetView: this.props.targetView,
            })
        }
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        var className = 'Bloc fade-in pointer '
        if (this.props.large) {
            className += 'bloc-full'
        } else {
            className += 'bloc-droit-2'
        }

        const style = {}

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////

        var premadeContent = (
            <div className="firstChoiceStyle" style={style}>
                <img src="svg/5min.svg" className="timer" alt="timer" />
                <div className="title bold-font">
                    Estimez votre crédit immobilier
                </div>
                <div className="subtitle">Meilleur taux et budget</div>
                <div className="bottomImageContainer">
                    <img src="svg/house.svg" className="home" alt="home" />
                    <img src="svg/tree.svg" className="tree" alt="tree" />
                </div>
            </div>
        )

        return (
            <div>
                <div
                    className={className}
                    style={style}
                    onClick={() => this.handleClickBloc()}
                >
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
    }
}

export default connect(mapStateToProps)(BlocParcoursEstimer)
